module.exports = __webpack_public_path__ + "img/img14.5b6cc895.svg";